import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'lib-tree-nodes',
  templateUrl: './tree-nodes.component.html',
  styleUrls: ['./tree-nodes.component.scss'],
})
export class TreeNodesComponent {
  constructor() {}

  @Input()
  public treeData: any[] = [];

  @ContentChild(TemplateRef)
  public nodeTemplate: TemplateRef<any> | null = null;
}
